/* sg-discount — capture a /discount/CODE link's code (?sg_code= or #sg=), resolve it
   against the sg-discount-data island (keyed by sha256(upcased code) so page source never
   exposes codes), persist it for the session, and expose one shared "active discount"
   state for the banner + offer. Display-only mirror; checkout is authoritative. */
(function () {
  var STORE_KEY = 'sgDiscount';

  function readData() {
    var el = document.querySelector('[data-sg-discount-data]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function sha256Hex(str) {
    if (!(window.crypto && window.crypto.subtle && window.TextEncoder)) {
      return Promise.reject(new Error('crypto unavailable'));
    }
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(function (buf) {
      var bytes = new Uint8Array(buf);
      var hex = '';
      for (var i = 0; i < bytes.length; i++) hex += (bytes[i] < 16 ? '0' : '') + bytes[i].toString(16);
      return hex;
    });
  }

  /* The island has no plaintext codes; the visitor's own link carried the code, so the
     matched entry is rebuilt with it (normalised) plus its hash for keyed lookups. */
  function findByCode(data, raw) {
    if (!raw) return Promise.resolve(null);
    var want = ('' + raw).trim().toUpperCase();
    if (!want) return Promise.resolve(null);
    return sha256Hex(want)
      .then(function (hash) {
        if (!Object.prototype.hasOwnProperty.call(data, hash)) return null;
        var entry = {};
        var payload = data[hash];
        for (var k in payload) {
          if (Object.prototype.hasOwnProperty.call(payload, k)) entry[k] = payload[k];
        }
        entry.code = want;
        entry.codeHash = hash;
        return entry;
      })
      .catch(function () {
        return null;
      });
  }

  function codeFromUrl() {
    try {
      var q = new URLSearchParams(window.location.search).get('sg_code');
      if (q) return q;
    } catch (e) {}
    var m = (window.location.hash || '').match(/(?:^#|&)sg=([^&]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function stripMarker() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('sg_code');
      var hash = (url.hash || '').replace(/(?:^#|&)sg=[^&]*/, '').replace(/^#&?/, '#');
      if (hash === '#') hash = '';
      url.hash = hash;
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    } catch (e) {}
  }

  function persist(code) {
    try {
      sessionStorage.setItem(STORE_KEY, code);
    } catch (e) {}
  }
  function restore() {
    try {
      return sessionStorage.getItem(STORE_KEY);
    } catch (e) {
      return null;
    }
  }

  function apply(entry) {
    window.SG = window.SG || {};
    window.SG.discount = entry;
    var html = document.documentElement;
    html.setAttribute('data-sg-discount', entry.code);
    html.classList.add('is-discount-active');
    document.querySelectorAll('[data-sg-discount-banner]').forEach(function (el) {
      if (entry.bannerHtml) el.innerHTML = entry.bannerHtml;
    });
    document.dispatchEvent(new CustomEvent('sg:discount', { detail: entry }));
  }

  function boot() {
    var data = readData();
    var raw = codeFromUrl();
    var fromUrl = !!raw;
    if (!raw) raw = restore();
    findByCode(data, raw).then(function (entry) {
      if (!entry) {
        if (fromUrl) stripMarker();
        return;
      }
      persist(entry.code);
      if (fromUrl) stripMarker();
      apply(entry);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
